export enum UserGenderTypes {
    male = 'Male',
    female = 'Female',
    nonbinary = 'Nonbinary',
    notsay = 'Prefer not to say',
}